export function pct(a: number, b: number): number {
  return b > 0 ? (a / b) * 100 : 0;
}

export function fpct(a: number, b: number, dp = 1): string {
  if (b <= 0) return "0%";
  return `${pct(a, b).toFixed(dp)}%`;
}

export function fnum(n: number): string {
  return n.toLocaleString("en-US");
}

export function fdate(iso: string | null): string {
  if (!iso) return "–";
  const d = new Date(iso);
  if (isNaN(d.getTime())) return iso;
  return d.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
}

/** "12 Sep 2026, 14:30" for snapshot timestamps. */
export function fstamp(iso: string): string {
  const d = new Date(iso);
  if (isNaN(d.getTime())) return iso;
  return d.toLocaleString("en-GB", {
    day: "2-digit", month: "short", year: "numeric",
    hour: "2-digit", minute: "2-digit",
  });
}

export const COLORS = {
  done: "var(--s-done)",
  await: "var(--s-await)",
  est: "var(--s-est)",
  none: "var(--s-none)",
  high: "var(--sev-high)",
  med: "var(--sev-med)",
  low: "var(--sev-low)",
  good: "var(--good)",
} as const;
